import { render, staticRenderFns } from "./websiteHomecn.vue?vue&type=template&id=96aa9b00&scoped=true&"
import script from "./websiteHomecn.vue?vue&type=script&lang=js&"
export * from "./websiteHomecn.vue?vue&type=script&lang=js&"
import style0 from "./websiteHomecn.vue?vue&type=style&index=0&id=96aa9b00&prod&scoped=true&lang=css&"
import style1 from "./websiteHomecn.vue?vue&type=style&index=1&id=96aa9b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aa9b00",
  null
  
)

export default component.exports